/**
 * @param {*} value
 * @returns {boolean}
 */
export default function isEmptyString(value) {
    return value === '';
}
